import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { EntityLoading } from '../Entity/Entity.loading';

const FILE_COUNT = 8;

export const EntityListLoading: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column">
      {times(FILE_COUNT).map((key, index) => (
        <EntityLoading key={key} borderBottom={index === FILE_COUNT - 1 ? 'none' : '1px solid'} />
      ))}
    </Box>
  );
};
